<template>
  <div class="wrapper">
    <div class="container details">
      <div class="row"><div class="col-md-10"><h1>Statistik leveranser</h1></div></div>
      <div class="row">
        <div class="col-md-7">
          <div class="bg-white mt-4 p-4 border-solid">
            <h2>Välj period</h2>
            <div class="d-flex">
              <div class="mr-2">
                <label>Startdatum</label>
                <Calendar v-model="selectedStartDate" view="month" dateFormat="yy-mm-dd" :showTime="false" :locale="sv" />
                <!--<Dropdown v-model="selectedYear" :options="years" optionLabel="name" placeholder="Välj år"/>-->
              </div>
              <div class="mr-2">
                <label>Slutdatum</label>
                <Calendar v-model="selectedEndDate" view="month" dateFormat="yy-mm-dd" :showTime="false" :locale="sv" />
              </div>
              <div class="mr-2">
                <Button v-if="selectedStartDate && selectedEndDate" label="Generera rapport" @click="onGenerate()"></Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-7">
          <div class="mt-4">
            <DataTable :value="tariff" dataKey="name">
              <Column field="name" header="Grupp" bodyStyle="text-align:center">
                <template #footer><strong>Totalt: </strong></template>
              </Column>
              <Column field="deliveries" header="Leveranser" bodyStyle="text-align:center">
                <template #footer>{{ totalDeliveries }} </template>
              </Column>
              <Column field="extra" header="Extra lossningar" bodyStyle="text-align:center">
                <template #footer>{{ totalExtraDeliveries }} </template>
              </Column>
              <Column field="blows" header="Överblåsningar" bodyStyle="text-align:center">
                <template #footer>{{ totalBlows }} </template>
              </Column>
              <Column field="washes" header="Tvättar" bodyStyle="text-align:center">
                <template #footer>{{ totalWashes }} </template>
              </Column>
              <Column field="unAnnounced" header="Oaviserade" bodyStyle="text-align:center">
                <template #footer>{{ totalUnannounced }} </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Row from 'primevue/row'
import ColumnGroup from 'primevue/columngroup'
import Button from 'primevue/button'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import Dropdown from 'primevue/dropdown'
import ProgressSpinner from 'primevue/progressspinner'
import Toast from 'primevue/toast'
export default {
  name: 'DeliveryStats',
  components: {
    DataTable,
    Column,
    Button,
    'Toast': Toast,
    moment,
    ColumnGroup,
    Calendar,
    Row,
    ProgressSpinner,
    Dropdown
  },
  data () {
    return {
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy',
        weekHeader: 'vk'
      },
      years: [],
      tariff: [],
      selectedStartDate: null,
      selectedEndDate: null,
      selectedYear: null,
      totalDeliveries: null,
      totalExtraDeliveries: 0,
      totalUnannounced: 0,
      totalWashes: 0,
      totalBlows: 0
    }
  },
  async mounted () {
    this.createYearArray()
  },
  watch: {
    selectedEndDate (newDate) {
      if (newDate) {
        const lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0)
        if (newDate.getDate() !== lastDay.getDate()) {
          this.selectedEndDate = lastDay
        }
      }
    }
  },
  methods: {
    async onGenerate () {
      this.getDefaultTariff()
      this.totalBlows = 0
      this.totalExtraDeliveries = 0
      this.totalWashes = 0
      this.totalDeliveries = 0
      this.totalUnannounced = 0
      let startDate = this.selectedStartDate
      let endDate = this.selectedEndDate
      let response = await this.$http.get('/api/orders/by-daterange/between/' + startDate + '/' + endDate)
      let orders = response.data.filter((x) => x.type === 'feralco')
      const data = this.groupOrders(orders)
      this.totalDeliveries = data.length
      for (let order of data) {
        this.totalBlows += order.nbrBlowOvers
        this.totalExtraDeliveries += (order.nbrDeliveries - order.includedDeliveries)
        this.totalWashes += order.washes
        this.totalUnannounced += order.unAnnounced
        let tariff = this.getTariff(order.totalAmount)
        if (tariff !== undefined) {
          tariff.deliveries += 1
          tariff.extra += (order.nbrDeliveries - order.includedDeliveries)
          tariff.blows += order.nbrBlowOvers
          tariff.washes += order.washes
          tariff.unAnnounced += order.unAnnounced
        }
      }
    },
    createYearArray () {
      const currentYear = new Date().getFullYear()
      const yearsArr = []
      for (let year = 2018; year <= currentYear; year++) {
        yearsArr.push({
          name: year,
          value: year
        })
      }
      this.years = yearsArr
    },
    groupOrders (orders) {
      let invoiceGrouped = {}
      for (const order of orders) {
        const group = this.getGroup(order)
        !(group in invoiceGrouped) && (invoiceGrouped[group] = {
          orderId: order.id,
          includedDeliveries: 0,
          nbrBlowOvers: 0,
          washes: 0,
          nbrDeliveries: 0,
          totalAmount: 0,
          unAnnounced: 0,
          totalOrderedAmount: 0,
          returnedAmount: 0,
          correct: true
        })
        const loadedAmount = this.countDeliveredAmount(order.data.orderRows[0].actions, group.startsWith('NoGroup'))
        invoiceGrouped[group].nbrBlowOvers += this.countBlowovers(order.data.orderRows[0].actions)
        invoiceGrouped[group].washes += this.countWashes(order.data.orderRows[0].actions)
        invoiceGrouped[group].nbrDeliveries += this.countDeliveries(order.data.orderRows[0].actions)
        invoiceGrouped[group].totalAmount += loadedAmount
        invoiceGrouped[group].totalAmount -= this.countReturnedAmount(order.data.orderRows[0].actions)
        invoiceGrouped[group].returnedAmount += this.countReturnedAmount(order.data.orderRows[0].actions)
        invoiceGrouped[group].unAnnounced += this.countUnAnnounced(order.data.orderRows[0].actions)
        if (order.data.Quantity !== undefined) {
          invoiceGrouped[group].totalOrderedAmount += parseFloat(order.data.Quantity.replace(',', '.'))
        }
        for (const priceGroup in invoiceGrouped) {
          this.setIncludedDeliveries(invoiceGrouped[priceGroup])
        }
      }
      return Object.values(invoiceGrouped)
    },
    getGroup (order) {
      return !order.data.GroupLoading || order.data.GroupLoading.length === 0 ? 'NoGroup' + order.id : order.data.GroupLoading
    },
    countUnAnnounced (actions) {
      return actions.filter(a => a.name === 'Lossar' && a.unAnnounced === true).length
    },
    countDeliveredAmount (actions, groupedLoading) {
      const loadedAmounts = actions.filter(a => a.name === 'Lossar' || (groupedLoading && a.name === 'Retur'))
      return loadedAmounts.reduce((prev, curr) => {
        const val = curr.amount === '' ? 0 : parseFloat(curr.amount)
        return prev + val
      }, 0)
    },
    countReturnedAmount (actions) {
      return actions.filter(a => a.name === 'Retur').reduce((prev, curr) => {
        return prev + parseFloat(curr.amount)
      }, 0)
    },
    countBlowovers (actions) {
      const blowovers = actions.filter(a => ((a.name === 'Läktring') || (a.name === 'Överblåsning')))
      return blowovers.reduce((prev, curr) => {
        return prev + Number(curr.amount)
      }, 0)
    },
    countDeliveries (actions) {
      return actions.filter(a => a.name === 'Lossar' && a.unAnnounced !== true).length
    },
    countWashes (actions) {
      const washes = actions.filter(a => ((a.name === 'Tvätt')))
      return washes.reduce((prev, curr) => {
        return prev + Number(curr.amount)
      }, 0)
    },
    setIncludedDeliveries (group) {
      try {
        group.includedDeliveries = group.includedDeliveries !== 0 ? group.includedDeliveries : this.getIncludedDeliveries(group).nbr
      } catch (e) {
        group.includedDeliveries = 0
        group.correct = false
      }
    },
    getTariff (amount) {
      return this.tariff.find(el => (this._.inRange(amount, el.range.low, el.range.high)))
    },
    getInfoTableInRangeForAmount (amount) {
      return this.infoTable().find(el => (this._.inRange(amount, el.range.low, el.range.high)))
    },
    getIncludedDeliveries (group) {
      let infoEntry = this.getInfoTableInRangeForAmount(group.totalOrderedAmount)
      if (infoEntry === undefined && group.totalOrderedAmount > group.totalAmount) {
        infoEntry = this.getInfoTableInRangeForAmount(group.totalAmount)
      }
      return infoEntry
    },
    infoTable () {
      return [
        {
          range: { low: 0, high: 18.499 },
          nbr: 1
        },
        {
          range: { low: 18.500, high: 24.98 },
          nbr: 1
        },
        {
          range: { low: 24.99, high: 30.09 },
          nbr: 1
        },
        {
          range: { low: 30.09, high: 35.09 },
          nbr: 1
        },
        {
          range: { low: 35.09, high: 40.09 },
          nbr: 4
        },
        {
          range: { low: 40.09, high: 42.09 },
          nbr: 4
        },
        {
          range: { low: 42.09, high: 99 },
          nbr: 1
        }
      ]
    },
    getDefaultTariff () {
      this.tariff = [
        {
          name: '10,6-18,0',
          range: { low: 0, high: 18.499 },
          deliveries: 0,
          extra: 0,
          blows: 0,
          washes: 0,
          unAnnounced: 0
        },
        {
          name: '18,1-24,9',
          range: { low: 18.500, high: 24.98 },
          deliveries: 0,
          extra: 0,
          blows: 0,
          washes: 0,
          unAnnounced: 0
        },
        {
          name: '25,0-30,0',
          range: { low: 24.99, high: 30.08 },
          deliveries: 0,
          extra: 0,
          blows: 0,
          washes: 0,
          unAnnounced: 0
        },
        {
          name: '30,1-35,0',
          range: { low: 30.09, high: 35.09 },
          deliveries: 0,
          extra: 0,
          blows: 0,
          washes: 0,
          unAnnounced: 0
        },
        {
          name: '35,1-40,0',
          range: { low: 35.09, high: 40.09 },
          deliveries: 0,
          extra: 0,
          blows: 0,
          washes: 0,
          unAnnounced: 0
        },
        {
          name: '40,1-42,0',
          range: { low: 40.09, high: 42.09 },
          deliveries: 0,
          extra: 0,
          blows: 0,
          washes: 0,
          unAnnounced: 0
        },
        {
          name: '42,1-',
          range: { low: 42.09, high: 99 },
          deliveries: 0,
          extra: 0,
          blows: 0,
          washes: 0,
          unAnnounced: 0
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Statistics/DeliveryStats.vue